var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('background-triangle'),(this.$route.params.type == 'riasoc_general'
          || this.$route.params.type == 'identiteit'
          || this.$route.params.type == 'riasoc_kiesreis')?_c('cards-stack-game'):_vm._e(),(this.$route.params.type == 'waardenspel')?_c('waarden-game'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }